export default {
    CanUpdate: "canUpdate",
    CanUpdateApplicableFrom: "canUpdateApplicableFrom",
    CanUnlock: "canUnlock",
    CanCrystallise: "canCrystallise",
    CanUncrystallise: "canUncrystallise",
    CanSendForApproval: "canSendForApproval",
    CanBeSignedByCustomer: "CanBeSignedByCustomer_Docusign",
    CanVoid: "canVoid",
    CanVoidEnvelope: "canVoidEnvelope",
    CanMakeLive: "canMakeLive",
    CanRequestRenew: "canRequestRenew",
    CanRenew: "canRenew",
    CanResurrect: "canResurrect",
    CanUpdateProductSchedule_Sales: "canUpdateProductSchedule_Sales",
    CanUpdateProductSchedule_Admin_SerialNumbers: "canUpdateProductSchedule_Admin_SerialNumbers",
    CanUpdateProductSchedule_Admin_NonSerialNumbers: "canUpdateProductSchedule_Admin_NonSerialNumbers",
    CanUpdateProductSchedule_Ips: "canUpdateProductSchedule_Ips",
    CanMarkProductScheduleByIps: "canMarkProductScheduleByIps",
    CanSetReadOnly: "canSetReadOnly",
    CanArchive: "canArchive",
    CanUnarchive: "canUnarchive",
    CanBePreApprovedByPrincipal: "canBePreApprovedByPrincipal",
    CanResetSheetState: "canResetSheetState"
};